import { userService } from "../api/user-auth";

const state = {
  users: [],
  new_user: null,
};

const getters = {
  users: state => {
    return state.users;
  },
};

const actions = {
  loadUsers({ commit }, users) {
    commit("loadUsers", users);
  },
  getUsers({ dispatch, commit }) {
    userService.getJson("user/list").then(
      response => {
        if (response.ok) {
          commit("loadUsers", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSaveUser({ dispatch, commit }, user) {
    userService.put("user/" + user.id, user).then(
      response => {
        if (response.ok) {
          commit("updateUser", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreateUser({ dispatch, commit }, user) {
    userService.post("user/" + user.id, user).then(
      response => {
        if (response.ok) {
          commit("addUser", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
};

const mutations = {
  addUser(state, user) {
    state.users.push(user);
    state.new_user = user;
  },
  updateUser(state, user) {
    var index = state.users.findIndex(v => v.id == user.id);
    state.users[index] = user;
  },
  loadUsers(state, users) {
    state.users = users;
  },
  clear(state) {
    state.users = [];
  },
};

export const users = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
